<template>
    <div>
        <modal-assign-trip ref="asignTrip" :employees="employees" modalId="assignTripModal" title="Dodeljivanje vozila" :date="selected_date" @submited="hideModal()" />
        <modal-confirm @confirm="setSchedule" inputId="confirmModal" title="Potvrda upućivanja na radni nalog" message="Da li ste sigurni da želite da uputite radnika na odabrani radni nalog?"/>
        <modal-p-w-o-confirm @confirm="setSchedule" inputId="confirmPWOModal" :employee="selectedEmployee" :selectedDate="getDateTimeSeconds()" :assignData.sync="scheduleData" />


        <div class="table-title">
            <div class="container-xl">
                <div class="row">
                    <div class="btn-group col-md-4" role="group" aria-label="Basic outlined example">
                        <template v-if="user.role == 'ADMIN'">
                            <router-link :to="{ name: 'EmployeesAssignment', params: {'initalSelectedDate': selected_date }}" class="btn btn-primary">Na radni nalog</router-link>
                            <router-link :to="{ name: 'EmployeesAssignmentTrip', params: {'initalSelectedDate': selected_date }}" class="btn btn-primary">Dodeli vozila</router-link>
                            <router-link :to="{ name: 'EmployeesAssignmentAndTrip'}" class="btn btn-primary active">Dnevni prikaz</router-link>
                        </template>
                        <template>
                            <button v-if="!editMode" class="btn btn-light" @click="startEdit">Izmeni</button>
                            <button v-else class="btn btn-light" @click="endEdit">Završi izmenu</button>
                        </template>
                    </div>

                    <div class="d-flex flex-wrap justify-content-end col-md-8">
                        <div>
                            <div class="form-floating">
                                <input type="date" class="form-control" id="woEndDate" v-model="selected_date" placeholder="Za datum" required @change="changeSelectedDays">
                                <label for="woEndDate">Za datum</label>
                                <div class="invalid-feedback">
                                    Unesite datum
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>



        <div class="col-lg-12 control-section" v-if="employees">
            <div class="e-mobile-content">
                <ejs-grid
                    v-if="gridReady"
                    ref="empAssignment"
                    :dataSource="employeesWorkers" 
                    :allowFiltering='true'
                    :allowSorting='true'
                    :showColumnMenu='true'
                    :allowGrouping='true'
                    :groupSettings='groupOptions'
                    :filterSettings='filterSettings'
                    :actionComplete='actionCompleteEvent'
                    :resizeStop='resizeEvent'
                    :created="createdTable"
                    :allowSelection='false'
                    :allowResizing='true'
                    :allowReordering='true'
                    gridLines='Both'
                    :queryCellInfo='customiseCell'
                    class="employess-table"
                    :enablePersistence='false'
                    height='100%'
                    :toolbar='toolbar'
                    :toolbarClick='clickHandler'
                    :allowExcelExport='true'
                    :allowPdfExport='true'
                    :recordDoubleClick="recordDoubleClick"
                    :actionFailure='actionFailure'
                    :dataBound='dataBound'
                    :refresh='loadEvent'
                    >
                    <e-columns>
                        <e-column field=''              index="3" order='4'    headerText='#' :template="rowIndexTemplate" :width='widthStates[0]' textAlign='Right' :visible='visibleStates[0]' ></e-column>
                        <e-column field='id'                headerText='ID'         :width='widthStates[1]' textAlign='Right' :isPrimaryKey='true' :visible='visibleStates[1]' ></e-column>
                        <e-column field='user.username'     headerText='Korisničko ime' :width='widthStates[2]' textAlign='Left' :visible='visibleStates[2]' :template="user.role==='ADMIN'?usernameTemplate:undefined"></e-column>
                        <e-column field='user.last_name'    headerText='Prezime'    :width='widthStates[3]' :visible='visibleStates[3]' ></e-column>
                        <e-column field='user.first_name'   headerText='Ime'        :width='widthStates[4]' :visible='visibleStates[4]' :customAttributes="infoAttributes" ></e-column>
                        
                        <e-column field='transport_type' :valueAccessor='transportTypeAccessor' headerText='Tip prevoza' :width='widthStates[5]'        :visible='visibleStates[5]' :customAttributes="infoAttributes" ></e-column>
                        <e-column field='user.role' :valueAccessor='roleAccessor' headerText='Uloga' :width='widthStates[6]'  :visible='visibleStates[6]' :customAttributes="infoAttributes" ></e-column>

                        <e-column v-for="time, timeId in allTimes" :key="timeId + selected_time" v :field='"timeline." + timeId + ".display"' :headerText='headerTextTimeAssign(time)'  width='177' 
                                :headerValueAccessor="assignTimeAccessor"
                                :template="editMode?pwoTemplate(timeId):undefined"
                                :visible='visibleStates[7+timeId]' :customAttributes="{class: 'time-col-' + timeId}" :disableHtmlEncode='false' :valueAccessor='timelineAccessor' ></e-column>
                        

                        <e-column v-for="time, timeId in tripsTimes" :key="timeId + selected_time" :field='"trip_timeline."+ timeId +".display"' :headerText="headerTextTimeTrip(time)"  width='177' 
                            :valueAccessor="tripTimelineAccessor" :headerValueAccessor="timeAccessor"
                            :template="editMode?vehicleChoice(timeId):null"
                            :visible='true' :customAttributes="{class: 'time-col-' + timeId}"
                            ></e-column>

                        <e-column v-if="!tripsTimes || tripsTimes.length === 0" field='tripTimeline' headerText='Nema voznji'  width='177' 
                            :visible='!tripsTimes || tripsTimes.length === 0'
                            ></e-column>
                        <!-- <e-column field='Freight' headerText='Freight' width='120' format='C2' textAlign='Right'></e-column>
                        <e-column field='ShippedDate' headerText='Shipped Date' width='130' format="yMd" textAlign='Right'></e-column>
                        <e-column field='ShipCountry' headerText='Ship Country' width='150'></e-column> -->
                    </e-columns>
                </ejs-grid>
            </div>


        </div>
                
        <div class="assignment-form-footer" v-if="editedEmployees > 0 || editedTrips">
            <div class="container">
                <div class="d-flex justify-content-between">
                    <h5 class="mt-2">Izmenili ste raspored <template v-if="editedTrips">i vozila</template></h5>
                    <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                        <button @click="submitAssignmentBtn" class="btn btn-primary">
                            Potvrdi
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import ModalConfirm from '@/components/modals/ModalConfirm.vue';
    import { Modal } from 'bootstrap';

    import EmployeesService from '@/service/EmployeesService.js';
    import TransportService from '@/service/TransportService.js';
    import CalendarService from '@/service/CalendarService.js';
    import UtilService from '@/service/UtilService.js';
    import {mapState} from 'vuex';
    import Vue from 'vue';

    import { Sort, Page, ColumnMenu, Filter, Group, Reorder, Resize, Freeze, Toolbar, PdfExport, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import DateTimeEmpAssignment from '@/components/grid-templates/DateTimeEmpAssignment.vue';
    import PreWorkOrderTemplate from '@/components/grid-templates/PreWorkOrder.vue';
    
    import ModalAssignTrip from '@/components/modals/assignment/ModalAssignTrip.vue';
    import VehicleChoice from '@/components/grid-templates/VehicleChoice.vue';
    import RowIndexTemplate from '@/components/grid-templates/RowIndex.vue';
    import ModalPWOConfirm from '../modals/ModalPWOConfirm.vue';
    import UsernameTemplate from '@/components/grid-templates/UsernameTemplate.vue';
    import WorkOrderService from '@/service/WorkOrderService.js';


    Vue.prototype.$eventHub = new Vue(); 


    export default {

        components: { ModalConfirm, ModalPWOConfirm, ModalAssignTrip },

        setup: {
            UtilService
        },
        provide: {
            grid: [Sort, Page, ColumnMenu, Filter, Group, Reorder, Resize, Freeze, Toolbar, PdfExport, ExcelExport ]
        },

        data: function() {
            return {
                
                gridReady: false,
                employees: [],
                selectedEmployee: null,
                preWorkOrders: {},

                allTimes: [],
                pwoSchedulesMap: {},
                currentEmployeeWO: {},

                assignTripModal: null,
                currentWorkOrder: {
                    workOrderId: null,
                    date: null
                },

                selected_date: UtilService.formatDatePattern(UtilService.getMoment()),
                selected_time: "00:00",
                selected_days: 1,

                modalConfirm: null,
                scheduleData: {},
                absences: null,
                pwoTimeline: null,


                groupOptions: { showGroupedColumn: true, columns: [] },
                groupOptionsLoadedColumns: [],
                filterSettings: { type: "Excel" },
                
                visibleStates: [true, false, false, true, true, true, false, true],
                widthStates: [60, 120, 120, 130, 130, 150, 150, 377, 177, 177, 177, 177, 177,],
                orderStates: [],
                groupState: [],

                infoAttributes: {class: 'col-info-side'},

                nonWorkingDays: [],
                employeesDayStatus: {},

                workAttendances: [],

                editedEmployees: 0,

                editedTrips: false,
                
                userTripsMap: {},
                tripsTimes: [],

                editMode: false,


                vehiclesCapacity: {},

                toolbar: [

                    { text: 'Exprot Excel', tooltipText: 'Izvezi Excel', prefixIcon: 'e-excelexport', id: 'exportExcel', align: 'Right'},
                    { text: 'Exprot PDF', tooltipText: 'Izvezi PDF', prefixIcon: 'e-pdfexport', id: 'exportPDF', align: 'Right'},
                    { text: 'Print', tooltipText: 'Štampaj', prefixIcon: 'e-print', id: 'print', align: 'Right'},
                    ],

                dateTimeHeaderTemplate() {
                    return {
                        template: DateTimeEmpAssignment
                    };
                },

                vehicleChoice(val) {
                    return () => {
                        let self = this;
                        return {
                            template: {
                                parent: self,
                                extends: VehicleChoice,
                                propsData: {'selected_date': this.selected_date, 'timelineTripIndex': val}
                            }
                        }
                    }
                },


                setVehicle(userId, vehicleId) {
                    let employee = this.employees.find(x => x.id == userId);
                    if (!employee) return;

                    if (!employee.currentTripAssign.edited) {
                        this.$set(employee.currentTripAssign, "old_vehicle", employee.currentTripAssign.vehicle)
                    }

                    employee.currentTripAssign.vehicle = vehicleId;
                    this.$set(employee.currentTripAssign, "edited", true)
                    this.calculateCapacity();

                    this.enableEditMode();
                },

                enableEditMode() {
                    this.editedTrips = true;
                    this.$store.dispatch('enableClosePrompt', {message: "Niste potvrdili izmenu"});
                },

                disableEditMode() {
                    this.editedTrips = false;
                    
                    this.$store.dispatch('disableClosePrompt');
                    this.clearEdited();
                },

                clearEdited() {
                    this.employees.forEach(employee => {
                        if (employee?.currentTripAssign?.edited)
                            employee.currentTripAssign.edited = false;
                    });
                    this.$refs.empAssignment.getCurrentViewRecords().forEach(employee => {
                        if (employee?.currentTripAssign?.edited)
                            employee.currentTripAssign.edited = false;
                    });

                },

                pwoTemplate(timeId) {
                    return () => {
                        return {
                            template: {
                                extends: PreWorkOrderTemplate,
                                propsData: {timeId: timeId, dateTimeSeconds: this.getDateTimeSeconds()},
                            }
                        }
                    }
                },

                rowIndexTemplate() {
                        return {
                            template: {
                                extends: RowIndexTemplate,
                            }
                        }

                },


                usernameTemplate: function() {
                    return {
                        template: UsernameTemplate
                    };
                },

            };
        },  
        computed: {
            ...mapState([
                'allWorkOrders',
                'userSettings',
                'userTrips',
                'transportVehicles',
                'user',
            ]),

            employeesWorkers() {
                let workers = []
                this.employees.forEach(employee => {
                    // if (employee.user.role == "ADMIN") return;
                    workers.push(employee)
                });

                return workers

            },

            todayTimeId() {
                return this.allTimes.indexOf(this.getDateTimeSeconds());
            },

            isWeekend() {
                let selected_date = new Date(this.selected_date);
                if (selected_date.getDay() == 0 || selected_date.getDay() == 6) return true;
                return false;

            },

            todayDateTime() {
                return UtilService.formatDatePattern() + "T00:00:00";
            },

            totalVehicles() {
                let vehicles = 0;
                Object.values(this.vehiclesCapacity).forEach(capacity => {
                    if (capacity > 0) vehicles++;
                });
                return vehicles;
            }
        },

        methods: {

            formatDate: UtilService.formatDate,
            translateRole: UtilService.translateRole,
            absenceTypeFormat: UtilService.absenceTypeFormat,
            translateTransportType: UtilService.translateTransportType,

            roleAccessor(field, data) {
                if (field == "key") return this.translateRole(data.key);

                return this.translateRole(data['user'].role);
            },

            transportTypeAccessor(field, data) {
                if (field == "key") return this.translateTransportType(data.key);

                return this.translateTransportType(data['transport_type']);
            },

            async changedDateLoad() {
                await this.loadTimelineWorkorders();

            },

            submitAssignmentBtn() {
                this.editedEmployees = 0;

                if (this.editedTrips) {
                    this.showAssignModal();
                } else {
                    this.loadTimelineWorkorders();
                    this.toast("Upueno")
                    this.endEdit();
                }
            },

            toast(message, type) {
                this.$toasted.show(message, { 
                    type: type,
                    theme: "toasted-primary", 
                    position: "top-center", 
                    duration : 20000
               });
            },

            getCreatedByTag(data, tooltip) {
                return "<small title='Izmenjeno: " + UtilService.formatDateTime(tooltip) +  "'>" + data.first_name + " " + data.last_name + "</small>";
            },

            timelineAccessor(field, data) {
                if (field == "key") return data.key;
                let fieldTokens = field.split('.');
                if (!data.timeline) return "";

                let pwo = data.timeline[fieldTokens[1]];
                let role = pwo?.pwo_role==1 && pwo.working?"(M) ":"";
                let name = pwo?.display?pwo.display:""

                let wo_tag = "<span>" + role + name + "</span>"

                if (pwo?.manager_changed && pwo?.created_by_obj) {
                    wo_tag += "<br>"
                    wo_tag += this.getCreatedByTag(pwo.created_by_obj, pwo.created_at)
                }

                return wo_tag;
            },

            formatDateAndOrTime(str) {
                let date = UtilService.convertMoment(str);
                if (date.format('HH:mm:ss') === "00:00:00") {
                    return UtilService.formatDate(date)
                } else {
                    return UtilService.formatDateTime(date)
                }

            },

            timeAccessor(field, column) {

                let timeIndex = column.field.split(".")[1];
                let timeValue = this.tripsTimes[timeIndex];
                return UtilService.formatTime(timeValue);
            },

            assignTimeAccessor(field, column) {
                let timeIndex = column.field.split(".")[1];
                let timeValue = this.allTimes[timeIndex];
                return this.formatDateAndOrTime(timeValue);            },

            headerTextTimeTrip(timeValue) {
                return "Voznja u " + UtilService.formatTime(timeValue);
            },

            headerTextTimeAssign(timeValue) {
                return "Upućenje " + this.formatDateAndOrTime(timeValue);
            },


            customiseCell(args) {
                let currentDay;
                if (args.column.field.startsWith('timeline.') == true) {
                    let trimmed = args.column.field.slice(9);
                    let nextDot = trimmed.indexOf('.');
                    trimmed = trimmed.slice(0, nextDot);

                    if (args.data?.timeline == null) return;
                    currentDay = args.data?.timeline[trimmed];
                    if (!currentDay) return;

                    if (currentDay.absence_type) {
                        args.cell.classList.add('absence-day');
                        if (currentDay.absence_type == 'VACATION') args.cell.classList.add('absence-vacation-day');
                        else if (currentDay.absence_type == 'SICKNESS') args.cell.classList.add('absence-sickness-day');
                        else if (currentDay.absence_type == 'RELIGIOUS') args.cell.classList.add('absence-religious-day');
                        else args.cell.classList.add('absence-other-day');
                    } else if (currentDay.non_working_day && !currentDay.force_working_day) {
                        args.cell.classList.add('non-working-day');
                    } else if (currentDay.work_order === null) {
                        args.cell.classList.add('no-work-order');
                    } else if (currentDay.working && currentDay.date <= this.todayDateTime && currentDay.appeared == undefined) {
                        args.cell.classList.add('not-appeared')
                    }


                    if (currentDay.edited) {
                        args.cell.classList.add('edited')
                    }
                    // if (currentDay.nonWorkingDay) {
                    //     args.cell.classList.add('non-working-day');
                    // }


                    
                }

                if (args.column.field.startsWith('w1.') == true || args.column.field.startsWith('w2.') == true) {
                    let pref = args.column.field.slice(0,2);
                    currentDay = args.data?.[pref];
                    if (!currentDay) return;

                    
                    if (currentDay.absence_type) {
                        args.cell.classList.add('absence-day');
                        if (currentDay.absence_type == 'VACATION') args.cell.classList.add('absence-vacation-day');
                        else if (currentDay.absence_type == 'SICKNESS') args.cell.classList.add('absence-sickness-day');
                        else if (currentDay.absence_type == 'RELIGIOUS') args.cell.classList.add('absence-religious-day');
                        else args.cell.classList.add('absence-other-day');
                    } else if (currentDay.non_working_day && !currentDay.force_working_day) {
                        args.cell.classList.add('non-working-day');
                    } else if (currentDay.work_order === null) {
                        args.cell.classList.add('no-work-order');
                    } else if (currentDay.working && currentDay.date <= this.todayDateTime && currentDay.appeared == undefined) {
                        args.cell.classList.add('not-appeared')
                    }
                    

                }

            },

            changeSelectedDays() {
                this.loadTimelineWorkorders();
            },

            validateForm(form) {
                form.classList.add('was-validated');
                if (this.selectedEmployee == "" || this.currentWorkOrder.workOrderId == "" || this.currentWorkOrder.date == "")
                    return false;
    
                return form.checkValidity();
            },

            async loadActiveWorkOrders() {
                await this.$store.dispatch('loadAllWorkOrders');
            },

            getDateTime() {
                return this.selected_date + 'T' + this.selected_time;
            },


            getDateTimeSeconds() {
                return this.selected_date + 'T' + this.selected_time + ':00';
            },

            async loadTimelineWorkorders() {
                await this.loadTrips();

            },

            async loadTrips() {
                let data = {
                    'start_date': this.selected_date,
                    'end_date': this.selected_date
                }
                console.log("loadTrips");

                this.$store.dispatch('loadUserTrips', {'date': this.selected_date });

                const self = this;
                TransportService.getUserTripsTimeline(data).then(async (result)=>{
                    this.calculateTripsTimes(result.data)
                    this.timelineTripKeyValuesToIndex(result.data)
                    this.calcTripDisplayValue(result.data);
                    this.calcSelectedTrips(result.data);

                    this.employees = result.data.filter(x=> {
                        if (x.work_end_date && x.work_end_date <= self.selected_date) return false;
                        return true;

                    })

                    this.calculateCapacity();


                    await WorkOrderService.getPWOTimeline(data).then(async (pworesult)=>{

                        this.calculateAllTimes(pworesult.data);
                        this.timelineKeyValuesToIndex(pworesult.data)
                        this.calcPWODisplayValue(pworesult.data);


                        result.data.forEach(employee => {
                            let timeline = pworesult.data.find(x=>x.id === employee.id)?.timeline
                            if (!timeline) return;

                            employee.timeline = timeline;
                        })
                        

                    });

                    this.calcCurrentAssign(result.data);


                    this.refreshGrid();
                    this.gridReady = true;

                    
                });

            },

            calcPWODisplayValue(employees) {
                const self = this;
                employees.forEach(employee => {

                    if (!employee.timeline) return;
                    Object.values(employee.timeline).forEach(timeline_obj => {
                        

                        self.calcDeisplayValueForTimelineData(timeline_obj);

                    });

                });
            },

            calculateCapacity() {
                console.log("IDE CAPACITY");
                var props = Object.getOwnPropertyNames(this.vehiclesCapacity);
                for (var i = 0; i < props.length; i++) {
                    this.vehiclesCapacity[props[i]] = 0;
                }
                this.totalPassengers = 0

                this.employees.forEach(employee => {
                    if (!employee.currentTripAssign?.vehicle) return;
                    if (!this.vehiclesCapacity[employee.currentTripAssign.vehicle])  this.vehiclesCapacity[employee.currentTripAssign.vehicle] = 0;

                    this.vehiclesCapacity[employee.currentTripAssign.vehicle]++;
                    this.totalPassengers++;

                });

                this.vehiclesCapacity = Object.assign({},this.vehiclesCapacity);
                return this.vehiclesCapacity
            },

            calcTripDisplayValue(employees) {
                const self = this;
                employees.forEach(employee => {

                    if (!employee.trip_timeline) return;
                    Object.values(employee.trip_timeline).forEach(trip_obj => {
                        
                        self.calcDeisplayValueForTripData(trip_obj);

                    });

                });

            },

            calcDeisplayValueForTripData(trip_obj) {
                trip_obj.display = this.getTripDisplayValue(trip_obj);
            },

            getTripDisplayValue(trip_obj) {
                if (trip_obj.vehicle == -1) return "";
                let vehicle = this.transportVehicles.find(x=> x.id == trip_obj.vehicle);
                trip_obj.vehicle_obj = vehicle;
                return vehicle?.name;
            },

            calcSelectedTrips(employees) {
                const self = this;
                employees.forEach(employee => {

                    // if (employee.trip_timeline?.[selectedTimeId] == null) {
                    //     employee.trip_timeline[selectedTimeId] = self.getUndefinedSchedule();
                    // }
                    employee.currentTripAssign = employee.trip_timeline[self.getSlectedTripsId()];
                });
            },


            showAssignModal() {
                this.$refs.asignTrip.load();
                this.assignTripModal.show();
            },

            hideModal() {
                this.assignTripModal.hide();
                this.disableEditMode();

                this.loadTimelineWorkorders();
                this.editedEmployees = 0;

                this.endEdit();
            },




            calculateTripsTimes(timeline) {
                let first_timeline = timeline[0]['trip_timeline'];

                this.tripsTimes = Object.keys(first_timeline);

                this.$nextTick(() => {
                    this.tripsTimes = [];
                    this.$nextTick(() => {
                        this.tripsTimes = Object.keys(first_timeline);
                    })
                })
            },

            timelineTripKeyValuesToIndex(employees) {
                employees.forEach(employee => {
                    let trip_timeline = employee.trip_timeline;
                    let newTimeline = {}
                    if (trip_timeline != undefined) {
                        Object.values(trip_timeline).forEach((timeline_data, index) => {
                            newTimeline[index] = timeline_data;
                        });
                    }
                    
                    employee.trip_timeline = newTimeline;

                });
            },


            // TODO
            getSlectedTripsId() {
                return 0;
            },

            refreshGrid() {
                this.$refs.empAssignment?.refresh();
            },


            getUndefinedSchedule() {
                return {work_order:undefined, work_order_obj: {name:"/"}, display:"Neradni dan"};
            },


            async load_data() {
                await this.loadActiveWorkOrders();
                await this.loadAllVehicles();
                await this.loadTimelineWorkorders();

            },

            async loadAllVehicles() {
                await this.$store.dispatch('loadAllTransportVehicles', this.workOrderForm).catch((error) => {
                    console.log(error);
                    alert("Neuspešno učitavanje vozila")
                });
            },

            dateHasTime(str) {
                return UtilService.convertMoment(str).format('HH:mm:ss') !== "00:00:00"
            },

            setScheduleEvent(data, showModal = true) {
                console.log("SET SCHEDULE");
                this.scheduleData = data;
                this.selectedEmployee = this.employees.find(x => x.id == data.employee);
                this.gridSelectedEmplopyee = this.$refs.empAssignment.getCurrentViewRecords().find(x => x.id == data.employee);

                this.editedEmployees++;
                let timeIndex = this.allTimes.indexOf(data.date);
                this.selectedEmployee.timeline[timeIndex].edited = true;
                this.gridSelectedEmplopyee.timeline[timeIndex].edited = true;

                this.calcDeisplayValueForTimelineData(this.selectedEmployee.timeline[timeIndex]);
                this.calcDeisplayValueForTimelineData(this.gridSelectedEmplopyee.timeline[timeIndex]);

                this.refreshGrid();

                if (showModal) {
                    this.modalConfirm = new Modal(document.getElementById('confirmPWOModal'));
                    this.modalConfirm.show();
                    // this.loadTimelineWorkorders();
                } else {
                    this.setSchedule();

                }
            },

            async setSchedule() {
                let dateStr = this.scheduleData.date.slice(0,10)
                if (this.isNonWorkingDay(dateStr)){
                    let empDayStatus = {
                        employee_id: this.scheduleData.employee,
                        working: true,
                        date: dateStr,
                        deleted: false,
                    }
                    this.updateEmpDayStatus(empDayStatus)
                }


                try { 
                    await EmployeesService.addPreWorkOrderEmployee(this.scheduleData.employee, this.scheduleData); 
                } 
                catch (error) { console.log(error); }
                // this.loadTimelineWorkorders();
            },

            async setWorkingDay(data, cell_data) {
                this.$set(cell_data, 'force_working_day', true);
                this.$set(cell_data, 'edited', true);
                return await this.updateEmpDayStatus(data);

            },

            async deleteWorkingDay(data, cell_data) {
                cell_data.force_working_day = false;
                this.getDisplayValue(cell_data);
                return await this.deleteEmpDayStatus(data);
            },


            isDateToday(datetune) {
                let date = UtilService.convertMoment(datetune);
                return date.isSame(UtilService.getMoment(), 'day');
            },

            changeDate(datetime) {
                let date = UtilService.convertMoment(datetime);
                this.selected_date = date.format("YYYY-MM-DD")
                this.selected_time = date.format("HH:mm")
            },

            loadGroupOptions() {
                if (this.groupOptionsLoadedColumns.length == 0) return
                this.groupOptions.columns = this.groupOptionsLoadedColumns;
                console.log("loaded group opt");
            },

            calcDeisplayValue(employees) {
                const self = this;
                employees.forEach(employee => {

                    if (!employee.timeline) return;
                    Object.values(employee.timeline).forEach(timeline_obj => {
                        

                        self.calcDeisplayValueForTimelineData(timeline_obj);

                    });

                });
            },

            calcDeisplayValueForTimelineData(timeline_obj) {
                timeline_obj.working = this.isTimelineObjWorking(timeline_obj);
                timeline_obj.display = this.getDisplayValue(timeline_obj);
            },



            getDisplayValue(timeline_obj) {
                if (timeline_obj.absence_type) return UtilService.translateAbsenceType(timeline_obj.absence_type)
                if (timeline_obj.non_working_day && !timeline_obj.force_working_day) return "Neradni dan"
                if (timeline_obj.work_order_obj) return timeline_obj.work_order_obj.name;
                return "Neradni dan";
            },

            isTimelineObjWorking(timeline_obj) {
                if (timeline_obj.absence_type) return false
                if (timeline_obj.non_working_day && !timeline_obj.force_working_day) return false
                if (timeline_obj.work_order > 0) return true
                return false;
            },

            calcCurrentAssign(employees) {
                const self = this;
                let selectedTimeId = self.todayTimeId.toString();

                employees.forEach(employee => {

                    if (employee.timeline?.[selectedTimeId] == null) {
                        employee.timeline[selectedTimeId] = self.getUndefinedSchedule();
                    }
                    employee.currentAssign = employee.timeline[selectedTimeId];
                });
            },

            timelineKeyValuesToIndex(employees) {
                employees.forEach(employee => {
                    let timeline = employee.timeline;
                    let newTimeline = {}
                    if (timeline != undefined) {
                        Object.values(timeline).forEach((timeline_data, index) => {
                            newTimeline[index] = timeline_data;
                        });
                    }
                    
                    employee.timeline = newTimeline;

                });
            },

            calculateAllTimes(timeline) {
                let first_timeline = timeline[0]['timeline'];
                this.allTimes = Object.keys(first_timeline)
            },
            
            async updateEmpDayStatus(data) {

                try {
                    let result = await CalendarService.updateEmployeeDayStatus(data);
                    return this.nonWorkingDays[data.employee] = result.data;

                } catch (error) {
                    console.log(error);
                    alert("greska prilikom menjanja statusa radnog dana za radnika");
                    return false;
                }
            },

            async deleteEmpDayStatus(data) {

                try {
                    return await CalendarService.deleteEmployeeDayStatus(data);

                } catch (error) {
                    console.log(error);
                    alert("greska prilikom menjanja statusa radnog dana za radnika");
                    return false;
                }
            },

            findEmployeeAbsence(employeeId, date){
                let absence = this.absences.find(x => 
                    x.employee_id == employeeId &&
                    (x.end_date == null || UtilService.convertMoment(x.end_date).isSameOrAfter(date, 'day')) &&
                    UtilService.convertMoment(x.start_date).isSameOrBefore(date, 'day')
                    );
                return absence;
            },

            // async updatedHeaderEvent(event) {
            //     this.visibleStates[event.cell.colIndex] = event.cell.visible;
            // },

            resizeEvent(event) {
                this.saveColumnStatus(event.column)
                this.saveColumnStates();
            },

            actionCompleteEvent(event) {
                if (event.requestType == "columnstate") {
                    this.saveAllColumnsStatus(event.columns)
                } else if (event.requestType == "reorder") {
                    this.saveAllColumnsStatusOrderStatus()
                } else if (event.requestType == "grouping") {
                    this.groupingState(event.columnName);
                } else if (event.requestType == "ungrouping") {
                    this.unGroupingState(event.columnName);
                } else if (event.requestType == "refresh") {
                    this.fixGroupingLabel();
                }
                // console.log(event)
            },
            
            saveColumnStatus(column) {
                this.visibleStates[column.index] = column.visible;
                this.widthStates[column.index] = column.width;
            },

            resetTableTimelineVisibility() {
                let columns = this.$refs.empAssignment?.getColumns()
                if (!columns) return

                columns.forEach(column => {
                    if (!column.field.startsWith("timeline")) return

                    column.visible = true;
                    this.visibleStates[column.index] = column.visible;

                });
            },

            fixGroupingLabel() {
                let groupTags = document.querySelector('.employess-table .e-groupdroparea')?.children;
                if (!groupTags) return;
                groupTags.forEach(element => {
                    let text = element.firstChild.firstChild.innerText;

                    let reg1 = text.match('\\d{4}-[01]\\d-[0-3]\\d');
                    let reg2 = text.match('\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d');
                    if (reg2 != null) {
                        let rexp = new RegExp(reg2);
                        let formated = UtilService.formatDateTime(reg2[0])
                        element.firstChild.firstChild.innerText = text.replace(rexp, formated);
                    } else if (reg1 != null){
                        let rexp = new RegExp(reg1);
                        let formated = UtilService.formatDateTime(reg1[0])
                        element.firstChild.firstChild.innerText = text.replace(rexp, formated);
                        
                    }
                    
                });

                let groupsText = document.querySelectorAll('.employess-table .e-table .e-groupcaption');
                groupsText.forEach(element => {
                    let text = element.innerText;

                    let reg1 = text.match('\\d{4}-[01]\\d-[0-3]\\d');
                    let reg2 = text.match('\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d');
                    if (reg2 != null) {
                        let rexp = new RegExp(reg2);
                        element.innerText = text.replace(rexp, "").slice(1);
                    } else if (reg1 != null){
                        let rexp = new RegExp(reg1);
                        element.innerText = text.replace(rexp, "").slice(1);
                    }

                });


            },

            groupingState(column) {
                this.groupOptions.columns.push(column)
                this.saveColumnStates();
                this.fixGroupingLabel(column);


            },

            unGroupingState(column) {
                let index = this.groupOptions.columns.indexOf(column);
                if (index !== -1) {
                    this.groupOptions.columns.splice(index, 1);
                    this.saveColumnStates();

                }
            },

            saveAllColumnsStatus(columns) {
                columns.forEach(column => {
                    this.saveColumnStatus(column);
                });
                this.saveColumnStates();
            },

            saveAllColumnsStatusOrderStatus() {
                let columns = this.$refs.empAssignment?.getColumns()
                this.orderStates = []
                columns.forEach(element => {
                    if (element.field.startsWith('timeline')) return;

                    this.orderStates.push(element.field);

                });
                this.saveColumnStates();

            },

            saveAllColumnsStatusGrooupStatus() {
                this.saveColumnStates();
            },

            createdTable() {
                let columns = this.$refs.empAssignment.getColumns()
                this.saveAllColumnsStatus(columns);
                this.resetTableTimelineVisibility();
            },

            test() {
                alert("aloooo");
            },

            isNonWorkingDay(dateValue) {
                if (!dateValue) return false;

                let dateStr = dateValue.slice(0,10)
                return this.nonWorkingDays.some(d => d.date === dateStr );
            },

            isEmpWorkingDay(empId, dateValue) {
                let empStatuses = this.employeesDayStatus[empId];
                if (!empStatuses) return false;

                let dateStr = dateValue.slice(0,10);
                let dayStatus = empStatuses.find(d => d.date === dateStr);

                if (dayStatus?.working === true) return true;
                return false;
            },

            clickHandler(args) {

                switch (args.item.id) {
                    case 'exportExcel':
                        this.$refs.empAssignment.excelExport();
                        break;
                    case 'exportPDF':
                        this.$refs.empAssignment.pdfExport();
                        break;
                    case 'print':
                        this.$refs.empAssignment.print();
                        break;
                
                    default:
                        break;
                }

            },

            recordDoubleClick(event) {
                if (event.column.field.startsWith('timeline.') == true) {

                    let timeIndex = event.column.field.split(".")[1];
                    let timeValue = this.allTimes[timeIndex];

                    this.changeDate(timeValue)
                    this.loadTimelineWorkorders();
                }

            },

            actionFailure(args) { 
                console.log(args.error);
                                if (args.error.message.includes("reading 'visible'")) {
                    let columns = this.$refs.empAssignment.getColumns().map(x => x.field);

                    let beforeLen = this.groupOptions.columns.length;
                    this.groupOptions.columns = this.groupOptions.columns.filter(x => {
                        if (columns.indexOf(x) !== -1) return x;
                    })

                    if (beforeLen == 0) return
                    if (beforeLen == this.groupOptions.columns) {
                        this.groupOptions.columns.pop()
                    }
                    this.$refs.empAssignment.groupSettings = this.groupOptions

                    this.saveColumnStates();
                    this.gridReady = false;
                    this.$nextTick(() => {
                        this.gridReady = true;
                    })

                }
            },
            
            loadLocalStorage() {
                if (this.userSettings?.empAssignmentAndTrip?.grid?.width !== undefined) this.widthStates = this.userSettings.empAssignmentAndTrip.grid.width;
                if (this.userSettings?.empAssignmentAndTrip?.grid?.visible !== undefined) this.visibleStates = this.userSettings.empAssignmentAndTrip.grid.visible;
                if (this.userSettings?.empAssignmentAndTrip?.grid?.order !== undefined) this.orderStates = this.userSettings.empAssignmentAndTrip.grid.order;
                if (this.userSettings?.empAssignmentAndTrip?.grid?.group !== undefined) this.groupOptions.columns = this.userSettings.empAssignmentAndTrip.grid.group;
                
            },


            saveColumnStates() {
                let path = "empAssignmentAndTrip.grid"
                let save_data = {
                    width: this.widthStates,   
                    visible: this.visibleStates,   
                    order: this.orderStates,
                    group: this.groupOptions.columns
                }
                this.$store.dispatch('updateUserSettings', { path, save_data });
            },

            dataBound() {
                this.autoFitTimelineColumns();
            },

            autoFitTimelineColumns() {
                let columns = this.$refs.empAssignment.getColumns();

                columns.forEach(column => {
                    if (column.field.startsWith('timeline'))
                    this.$refs.empAssignment.autoFitColumns([column.field]);
                });

            },

            rerednerGrid() {
                this.gridReady = false;
                this.$nextTick(() => {
                    this.gridReady = true;
                })
            },


            startEdit() {
                this.editMode = true;
                this.rerednerGrid();
            },


            endEdit() {
                this.editMode = false;
                this.rerednerGrid();
            },

            async reorderColuns() {
                await this.$refs.empAssignment.reorderColumns(this.orderStates, "");
            },

            loadEvent() {
                console.log("LOAD EVENT");
            },

            loadProp() {
                let initDate = this.$route.params.initalSelectedDate;
                if (initDate) this.selected_date = initDate;
            }

        },

        created() {
            this.loadProp();
            this.loadLocalStorage();
            this.load_data();
            // this.$eventHub.$on('setScheduleData', (data)=>{ this.setScheduleEvent(data) });
            // this.$eventHub.$on('deleteWorkingDay', (data)=>{ this.deleteWorkingDay(data) });

        },

        mounted() {
            this.assignTripModal = new Modal(document.getElementById('assignTripModal'));
        },

        beforeDestroy () {
            // this.$eventHub.$off('setScheduleData');
            // this.$eventHub.$off('deleteWorkingDay');
        },
    }
    
</script>

<style>
    .employess-table table .no-work-order {
        background: #777777;
        /* color: #777777 !important; */

    }
    .employess-table table tr:hover .no-work-order {
        background: #666666 !important;
        /* color: #666666 !important; */

    }
    .employess-table table .absence-vacation-day {
        background: #0dff00;
    }
    .employess-table table tr:hover .absence-vacation-day {
        background: #0cdd01 !important;
    }


    .employess-table table .absence-sickness-day {
        background: #c46453;
    }
    .employess-table table tr:hover .absence-sickness-day {
        background: #bf5644 !important;
    }

    .employess-table table .absence-religious-day {
        background: #c46453;
    }
    .employess-table table tr:hover .absence-religious-day {
        background: #bf5644 !important;
    }

    .employess-table table .absence-other-day {
        background: #ffb649;
    }
    .employess-table table tr:hover .absence-other-day {
        background: #e9a53e !important;
    }

    .employess-table table .non-working-day {
        background: #777777;
        /* color: #777777 !important; */
    }
    .employess-table table tr:hover .non-working-day {
        background: #666666 !important;
        /* color: #666666 !important; */
    }


    .employess-table table .edited {
        background: #FFFF00;
        font-weight: bold;
    }


    .employess-table table .not-appeared {
        background: #ff775f;
    }
    .employess-table table tr:hover .not-appeared {
        background: #ff5436 !important;
    }


    .employess-table table tr td.time-col-0 {
        border-left: 3px solid #e0e0e0 !important;
    }

    .employess-table.e-grid .e-gridheader { 
        position: -webkit-sticky; 
        position: sticky; 
        top: 0px; /* The height of top nav menu. */ 
        /* border-bottom: 1px solid #222; */
        box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.142);
        z-index: 1; 
    }

    .employess-table .e-groupdroparea .e-grouptext {
        width: 120px;
    }

    .employess-table .e-gridcontent > .e-content {
        height: calc(100vh - 250px) !important;
    }

    .employess-table .e-table .e-groupcaption {        
        font-size: 14px;
        font-weight: bold;
    }

    .employess-table .e-table tr.e-row {        
        height: 55px;
    }

</style>

<style scoped>

.container {
    min-height: 74vh;
}

.table-title {
    padding-bottom: 15px;
    background: #299be4;
    padding: 16px 30px;
    margin: 0 0 10px;
    border-radius: 3px 3px 0 0;
}

.table-title h2{
    margin: 5px 0 0;
    font-size: 1.8em;
}

.table-title .white-btn {
    height: 100%;    
    background: #fff;
    width: 100%;
}

.table-title .btn.btn-w:hover, .table-title .btn.btn-w:focus {
    color: #566787;
    background: #f2f2f2;
}

.table-title .btn .btn-title {
    margin-top: 20px;
}

.table-wrapper {
    min-width: 1000px;
    background: #fff;
    padding: 20px 25px;
    border-radius: 3px;
    box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
}


.table td, .table th {
    padding: .75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

table.table-striped tbody tr:nth-of-type(odd) {
    background-color: #fcfcfc;
}
.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05);
}

table.table-striped.table-hover tbody tr:hover {
    background: #f5f5f5;
}
table.table thead {
    font-size: 0.8em
}

.h4 {
    font-style: bold;
}

.card-img-top {
    width: 100%;
    height: 4vw;
    min-height: 150px;
    object-fit: cover;
}

#cards .card {
    min-height: 100px;
}

#cards .card-body {
    background: #ffffffa7;
    position: absolute;
    bottom: 0;
    width: 100%;
}

#cards .card:hover .card-body {
    background: #ffffffef;
    position: absolute;
    bottom: 0;
    width: 100%;
}

.time-close {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    background: #fff;
}

.table th.absence-day {

    background: orange;
}

.table th.no-work-order {
    background: gray;
}

.assignment-form-footer {
    width: 100%;
    height: 70px;
    padding-top: 10px;
    background: rgba(255, 255, 255, 0.83);
    position: sticky;
    z-index: 999;
    left: 0;
    right: 0;
    bottom: 0;
    padding-right: var(--bs-gutter-x, 0.75rem);
    padding-left: var(--bs-gutter-x, 0.75rem);
    margin-right: auto;
    margin-left: auto;
    box-shadow: rgba(0, 0, 0, 0.14) 0 -5px 5px;
}

.assignment-form-footer .container {
    min-height: 60px !important;
}

</style>